var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterxinline = function SvgTwitterxinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.467 16.417C12.356 16.239 5.513 5.583 4.9 4.605h1.874c.51.812 5.956 9.312 7.526 11.812h-1.832ZM2 18h1.95c.981-1.165 3.22-3.818 4.382-5.196.534.868 2.196 3.317 3.342 5.194H17c-.788-1.256-4.678-7.037-5.718-8.691 1.58-1.871 3.588-4.253 5.32-6.307h-1.95c-.254.303-3.325 3.943-4.115 4.88-.38-.61-3.018-4.782-3.076-4.88H2.254l5.292 8.426C7.112 11.95 2.679 17.176 2 18Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 3)",
    d: "M0 0h15v15H0z"
  })))));
};
export default SvgTwitterxinline;